import FB_NFT from './FB_NFT';

export default FB_NFT;
